import { render, staticRenderFns } from "./relic-detail-census-point-edit.vue?vue&type=template&id=ae21046a"
import script from "./relic-detail-census-point-edit.vue?vue&type=script&lang=js"
export * from "./relic-detail-census-point-edit.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-census-point-edit.vue?vue&type=style&index=0&id=ae21046a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports